export const ENTITY_DOESNT_EXIST_IN_COLOR = "Entity doesn't exists in that color";
export const NO_MOUNTING_RAILS = "No mounting rails found.";
export const NO_MOUNTING_RAIL = "No mounting rail.";
export const MOUNTING_RAIL_NOT_PART_OF_SOLUTION = "Mounting rail not part of solution.";
export const NOT_A_MOUNTING_RAIL = "Entity is not a mounting rail.";
export const NO_SELECTED_MOUNTING_RAIL = "Could not find selected mounting rail.";
export const UPRIGHT_NOT_CORRECTLY_REATTACHED = "Upright not correctly reattached to its mounting rail and is missing.";
export const NO_UPRIGHTS = "One or more uprights missing.";
export const UPRIGHT_DOESNT_EXIST = "Upright doesn't exist.";
export const NO_MOUNTING_RAIL_LENGTH = "Could not find length of mounting rail.";
export const MOUNTING_RAIL_CONNECTION_SERVICE_NOT_SET = "mountingRailConnectionService is null";
